import { rewardsApi } from "../../api/rewardsApi";

//**************** Actions that involve the store *****************//

//**************** Actions that don't involve the store *****************//
export async function fetchRewards(username) {
    const rewards = await rewardsApi().getRewards(username);
    return rewards.data.results;
}